import { BSRForm } from "./pricing/BSR";
import { ClearanceForm } from "./pricing/Clearance";
import { CUSTOM_DEFAULT_VALUES, ProgramsForm } from "./pricing/Custom";
import { ProfileForm } from "./pricing/Profiling";
import { MarginProfilingForm } from "./pricing/MarginProfiling";
import { MarginCRProfilingForm } from "./pricing/MarginCRProfiling";
import { PROGRAM_DEFAULTS } from "../constants";

/**
 * @typedef {object} ProgramTemplate
 * @property {string} id The program's `template_type`.
 * @property {import("../../../../i18n/types").TSelector} name
 * @property {string} engine
 * @property {import("../../../../i18n/types").TSelector} description
 * @property {boolean} [enabled] Disabled templates are offered to staff only.
 * @property {Record<string, unknown>} [defaultValues]
 * @property {import("react").ComponentType<Omit<import("react-hook-form").UseFormReturn<import("../../../../modules/programs/programFormValues").ProgramFormValues>, "handleSubmit">>} FormComponent
 *   Rendered with the form's methods spread in.
 */

/** @type {ProgramTemplate[]} */
const TEMPLATES = [
  {
    id: "MARGIN_PROFILING",
    name: ($) => $.programs.templates["Margin Profiling"],
    engine: "pricing",
    description: ($) => $.programs.templates["Margin Profiling description"],
    FormComponent: MarginProfilingForm,
  },
  {
    id: "CR_UNITS",
    name: ($) => $.programs.templates["Margin and CR Profiling"],
    engine: "pricing",
    description: ($) => $.programs.templates["Margin and CR Profiling description"],
    FormComponent: MarginCRProfilingForm,
  },
  {
    id: "CLEARANCE",
    engine: "pricing",
    name: ($) => $.programs.templates["Clearance"],
    description: ($) => $.programs.templates["Clearance description"],
    FormComponent: ClearanceForm,
  },
  {
    id: "BSR",
    name: ($) => $.programs.templates["Best Seller Rank"],
    engine: "pricing",
    description: ($) => $.programs.templates["Best Seller Rank description"],
    enabled: false,
    FormComponent: BSRForm,
  },
  {
    id: "PROFILE",
    name: ($) => $.programs.templates["Profile"],
    engine: "pricing",

    description: ($) => $.programs.templates["Profile description"],
    FormComponent: ProfileForm,
  },
  {
    id: "CUSTOM",
    name: ($) => $.programs.templates["Custom"],
    engine: "pricing",
    description: ($) => $.programs.templates["Define your own pricing rules"],
    defaultValues: CUSTOM_DEFAULT_VALUES,
    FormComponent: ProgramsForm,
  },
  // New budget placeholder templates
  {
    id: "CUSTOM",
    name: ($) => $.programs.templates["Custom"],
    engine: "budget",
    description: ($) => $.programs.templates["Define your own budget rules"],
    defaultValues: PROGRAM_DEFAULTS["budget"],
    FormComponent: ProgramsForm,
  },
  // New bidding placeholder templates
  {
    id: "CUSTOM",
    name: ($) => $.programs.templates["Custom"],
    engine: "bidding",
    description: ($) => $.programs.templates["Define your own bidding rules"],
    defaultValues: PROGRAM_DEFAULTS["bidding"],
    FormComponent: ProgramsForm,
  },
];

export default TEMPLATES;
